import React from 'react';
import styles from './circleLoader.module.scss';

export default function CircleLoader() {
  return <div className={styles.lds_hourglass}></div>;
}
